import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  getCampaignFundedByLabel,
  getCampaignOfferLabel,
  getCampaignPercentageBadge
} from '@/ducks/campaigns/campaigns.helpers'
import type { Campaign } from '@/ducks/campaigns/campaigns.types'

import Styles from './CampaignsTable.module.scss'

type Props = {
  campaign: Campaign
}

const CampaignOfferCell = ({ campaign }: Props) => {
  const { t } = useTranslation()
  const percentageBadge = getCampaignPercentageBadge(campaign, t)

  return (
    <div className={Styles.offerContent}>
      <div className={Styles.offerTitleRow}>
        <span className={Styles.offerTitle}>
          {getCampaignOfferLabel(campaign, t)}
        </span>
        {percentageBadge && (
          <span className={Styles.percentBadge}>{percentageBadge}</span>
        )}
      </div>
      <span className={Styles.offerSubtitle}>
        {getCampaignFundedByLabel(campaign, t)}
      </span>
    </div>
  )
}

export default CampaignOfferCell
